const faqs = [
    { 
        id: 1, 
        heading: 'Which destinations are best for first-time travelers?',
        content: 'Explore our handpicked beginner-friendly destinations, offering smooth itineraries and guided tours for a hassle-free travel experience.',
    },
    {
        id: 2,
        heading: 'What essentials should I pack for a tour?',
        content: 'Discover our recommended packing checklist, including travel essentials like documents, comfortable clothing, and must-have accessories for your trip.',
    },
    { 
        id: 3,
        heading: 'How can I ensure a safe and enjoyable journey?',
        content: 'Learn vital travel safety tips, including itinerary planning, health precautions, and how to navigate cultural differences for a smooth journey.',
    },
    {
        id: 4,
        heading: 'Do you offer eco-friendly travel options?',
        content: 'Learn about our eco-tourism packages designed to promote sustainable travel and minimize environmental impact while exploring beautiful destinations.',
    },
    {
        id: 5,
        heading: 'Are group tours available for booking?',
        content: 'Discover our scheduled group tours, including guided excursions, cultural trips, and adventure activities. Join fellow travelers for a memorable experience.',
    },
];

export default faqs;